import { render, staticRenderFns } from "./TheFavoritesWidget.vue?vue&type=template&id=42d3aab0&"
import script from "./TheFavoritesWidget.vue?vue&type=script&lang=js&"
export * from "./TheFavoritesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports